import React from "react";

import { Product, ImageAsset } from "@greeter/core";
import { doNothing, classNames } from "@greeter/util";
import { Card, CardContent, CardHeader } from "../Card";
import { AspectRatios } from "../AspectRatioBox/AspectRatioBox";
import { useLazyImage } from "../Hooks";
import { LazyCoverImage } from "@greeter/matter";

import css from "./ProductCard.module.scss";

export type ProductCardProps = {
  className?: string;
  onClick?: () => void;
  aspectRatio?: AspectRatios;
  product: Product;
};

export const ProductCard: React.FC<ProductCardProps> = ({
  onClick = doNothing,
  className = "",
  aspectRatio = "4:3",
  product,
}) => {
  const [ref, isLoading] = useLazyImage(product.coverUrl ?? "");

  return (
    <Card ref={ref} {...classNames(css.Card, className)} onClick={onClick}>
      <CardHeader>
        <LazyCoverImage
          src={
            product.coverAsset
              ? ImageAsset.findUriWithSizeOrDefault(
                  product.coverAsset,
                  "4x3-w512"
                )
              : product.coverUrl ?? ""
          }
        />
      </CardHeader>
      <CardContent className={css.CardContent}>
        <div className={css.CardTitle}>{product.title}</div>
        <div className={css.CardSubtitle}>
          {product.subTitle ? product.subTitle : "Inkl. bord"}
        </div>
        <hr />
        <div className={css.Footer}>
          <div className={css.Price}>{product.price} kr.</div>
        </div>
      </CardContent>
    </Card>
  );
};
